import styled from "styled-components"

const StyledOrderNav = styled.section`
  .steps-desktop {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border-top: 2px solid #000;
    margin: 0 0 85px 0;
    span {
      position: relative;
      margin: 48px 0 0 0;
      font-weight: 700;
      &:before {
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        border: 2px solid #000;
        background-color: #fff;
        border-radius: 50%;
        position: absolute;
        top: -60px;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
      &.current {
        &:before {
          width: 30px;
          height: 30px;
          background-color: #000;
          top: -65px;
        }
      }
      &:first-child {
        &:before {
          right: auto;
        }
      }

      &:last-child {
        text-align: right;

        &:before {
          left: auto;
        }
      }
    }
  }
  .steps-mobile {
    display: none;
  }
  @media screen and (max-width: 900px) {
    .steps-desktop {
      display: none;
    }
    .steps-mobile {
      display: block;
      margin-bottom: 40px;
      &__progress {
        position: relative;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 13px;
        &::before {
          content: "";
          position: absolute;
          z-index: 0;
          left: 0;
          right: 0;
          top: calc(50% - 1px);
          height: 2px;
          background-color: #000;
        }
        span {
          position: relative;
          z-index: 2;
          display: block;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: #fff;
          border: 2px solid #000;
          transition: 0.2s;
          &.current {
            width: 30px;
            height: 30px;
            background-color: #000;
          }
        }
      }
      &__desc {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .box-name {
          span {
            display: none;
            &.current {
              display: inline-block;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .steps-mobile {
      &__desc {
        span {
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }
`

export default StyledOrderNav
